module.exports = __webpack_public_path__ + "296e42f9a76f16a9023aa9d2afbf6101.MP3";